const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/analisar-pedido-acrescimo",
    name: "analisar-pedido-acrescimo",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["carga_horaria_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PedidosDeAcrescimo/AnalisarPedidoAcrescimo/AnalisarPedidoAcrescimo.vue"
      ),
  },
  {
    path: "/analisar-pedido-acrescimo/consultar/:id",
    name: "analisar-pedido-acrescimo-consultar",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["carga_horaria_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PedidosDeAcrescimo/AnalisarPedidoAcrescimo/AnalisarPedidoAcrescimoConsultar.vue"
      ),
  },
];

export default routes;
